<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="类别集">
              <global-select
                :value.sync="queryParams.categorySetIds"
                requestApi="/mdm/itemCategorySet/pullDownList"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ organizationId: organizationCodeOrigin }"
                :disabled="true"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="类别">
              <a-input v-model="queryParams.categoryDesc" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="启用条码">
              <a-select v-model="queryParams.barcodeEnabled" allowClear>
                <a-select-option v-for="(item) in statusOptionsCode" :key="item.dictValue">{{ item.dictLabel }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="备料分类">
              <global-select
                :value.sync="queryParams.deliveryTypes"
                selectType="selectMultiple"
                requestApi="/mdm/itemCategoryCode/deliveryTypeList"
                :selectItem="{ value: 'realValue', label: 'description' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="状态">
              <a-select v-model="queryParams.status" allowClear>
                <a-select-option v-for="(item) in statusOptions" :key="item.dictValue">{{ item.dictLabel }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleQuery" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button :disabled="isEdit" type="primary" @click="handleAdd()" v-hasPermi="['mdm:itemCategoryCode:add']">新增</a-button>
      <!-- <a-button @click="handleExport" v-hasPermi="['mdm:itemCategorySet:export']">导出</a-button> -->
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="idNew"
          :scroll="{ fixScreen: true, x: 1700 }"
          childrenColumnName="children"
          :expandedRowKeys.sync="expandedRowKeys"
          @expand="getChild"
          @successCallBack="successCallBack"
        >
          <template v-for="item in columns" :slot="item.dataIndex" slot-scope="{ text, record }">
            <div :key="item.dataIndex">
              <span v-if="item.dataIndex === 'operation'">
                <a v-if="!isEdit || currentId !== record.idNew" @click="handleEdit(record)" v-hasPermi="['mdm:itemCategoryCode:edit']">编辑</a>
                <a v-if="(!isEdit || currentId !== record.idNew) && record.indexArr.length <= 4" class="ml10" @click="handleAdd(record)">添加子项</a>
                <a v-if="isEdit && currentId === record.idNew" @click="handleSave(record)">保存</a>
                <a v-if="isEdit && currentId === record.idNew" @click="handleCancel(record)" class="ml10">取消</a>
              </span>
              <span v-else-if="item.type === 'select'">
                <span v-if="!isEdit || currentId !== record.idNew">{{ meaning(record, item.dataIndex) }}</span>
                <global-select
                  v-if="isEdit && currentId === record.idNew"
                  :value.sync="record[item.dataIndex]"
                  :selectType="item.selectType ? item.selectType : 'select'"
                  :requestApi="item.requestApi"
                  :selectData="setArray(item.dataList)"
                  :selectItem="{ value: item.value, label: item.label }"
                  :searchParam="item.searchParam ? item.searchParam : ''"
                  :allowClear="false"
                  size="small"
                  :assembleLabel="item.assembleLabel ? item.assembleLabel : false"
                  :dropdown-match-select-width="item.dropdownMatchSelectWidth === false ? false : true"
                  @change="selectChange(item.dataIndex, record)"
                />
              </span>
              <span v-else-if="item.type === 'input' && record.idNew === 'add'">
                <span v-if="!isEdit || currentId !== record.idNew">{{ record[item.dataIndex] }}</span>
                <a-input v-if="isEdit && currentId === record.idNew" v-model="record[item.dataIndex]" size="small" />
              </span>
              <span v-else-if="item.type === 'switch'">
                <a-switch v-if="!isEdit || currentId !== record.idNew" :disabled="true" :checked="record[item.dataIndex] === 'Y'" />
                <a-popconfirm
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="statusOnChange(record, item.dataIndex)"
                  @cancel="cancelHandleStatus(record)"
                >
                  <span slot="title">请确认是否<b>{{ record[item.dataIndex] === 'Y' ? '停用' : '启用' }}</b></span>
                  <a-switch v-if="isEdit && currentId == record.idNew" :disabled="false" :checked="record[item.dataIndex] === 'Y'" />
                </a-popconfirm>
              </span>
              <span v-else-if="item.type === 'text'">{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
              <span v-else>{{ text }}</span>
            </div>
          </template>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import { apiItemCategoryCodeList, apiItemCategoryCodeEdit, apiItemCategoryCodeAdd } from '@/api/mdm/matter/material-category'
import { generateLsTableResData } from '@/utils/util.js';

export default {
  // eslint-disable-next-line
  name: 'material-category-category',
  components: {},
  data () {
    return {
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiItemCategoryCodeList, true),
        pageCurrent: true
      },
      isEdit: false,
      currentId: "",
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        categorySetIds: undefined,
        categoryDesc: undefined,
        barcodeEnabled: undefined,
        deliveryTypes: undefined,
        status: undefined,
        fatherSegments: ""
      },
      // 启用条码
      statusOptionsCode: [
        {
          dictLabel: "是",
          dictValue: "Y"
        },
        {
          dictLabel: "否",
          dictValue: "N"
        }
      ],
      // 状态快码
      statusOptions: [
        {
          dictLabel: "有效",
          dictValue: "Y"
        },
        {
          dictLabel: "无效",
          dictValue: "N"
        }
      ],
      // 表格字段
      columns: [
        {
          title: '层',
          dataIndex: 'level',
          align: 'center',
          width: 150
        },
        {
          title: '类别代码',
          dataIndex: 'segment',
          scopedSlots: { customRender: 'segment' },
          align: 'center',
          width: 160,
          ellipsis: true,
          type: "input"
        },
        {
          title: '类别',
          dataIndex: 'segmentName',
          scopedSlots: { customRender: 'segmentName' },
          align: 'center',
          width: 160,
          type: "input"
        },
        {
          title: '物料计划员',
          dataIndex: 'plannerId',
          scopedSlots: { customRender: 'plannerId' },
          align: 'center',
          width: 160,
          type: "select",
          selectType: "selectSearch",
          focusGet: true,
          requestApi: '/mdm/itemCategoryCode/plannerList',
          value: 'realValue',
          label: 'description',
          searchParam: "userName"
        },
        {
          title: '启用条码',
          dataIndex: 'barcodeEnabled',
          scopedSlots: { customRender: 'barcodeEnabled' },
          align: 'center',
          type: "switch"
        },
        {
          title: '备料分类',
          dataIndex: 'deliveryType',
          scopedSlots: { customRender: 'deliveryType' },
          align: 'center',
          width: 160,
          type: "select",
          focusGet: true,
          requestApi: '/mdm/itemCategoryCode/deliveryTypeList',
          value: 'realValue',
          label: 'description'
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center',
          type: "switch"
        },
        {
          title: '最后修改人',
          dataIndex: 'updateBy',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '最后修改时间',
          dataIndex: 'updateTime',
          scopedSlots: { customRender: 'updateTime' },
          width: 170,
          align: 'center',
          type: "text"
        },
        {
          title: '创建人',
          dataIndex: 'createBy',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: 170,
          align: 'center',
          type: "text"
        },
        {
          title: '操作',
          width: 120,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          fixed: 'right'
        }
      ],
      expandedRowKeys: [] // 展开的行
    }
  },
  computed: {
    ...mapState({
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  created () {
    this.queryParams.categorySetIds = this.$route.query && this.$route.query.id || null;
  },
  mounted () {
    this.handleQuery()
  },
  methods: {
    // 接口请求成功后回调
    successCallBack (myDataSource) {
      const tableList = JSON.parse(JSON.stringify(myDataSource))
      for (let i = 0; i < tableList.length; i++) {
        tableList[i].idNew = `${tableList[i].idNew}${tableList[i].segment}`
        tableList[i].children = []
        // 子节点的传参
        const arr = []
        const arr3 = []
        arr.push(tableList[i].segment)
        arr3.push(tableList[i].segmentName)
        tableList[i].fatherSegments = arr
        tableList[i].segmentNames = arr3
        // 定位树数据的哪一条
        const arr2 = []
        arr2.push(i)
        tableList[i].indexArr = arr2
      }
      this.$refs.dataTable.myDataSource = tableList
    },
    // 新增、添加子项
    handleAdd (record) {
      const tableList = JSON.parse(JSON.stringify(this.$refs.dataTable.myDataSource))
      const obj = {
        segment: "",
        segmentName: "",
        plannerId: "",
        barcodeEnabled: "",
        deliveryType: "",
        status: "Y",
        idNew: "add"
      }
      // 新增
      if (!record) {
        tableList.unshift(obj)
        this.$refs.dataTable.myDataSource = tableList
        this.isEdit = true;
        this.currentId = obj.idNew;
        return false
      }
      // 添加子项
      if (this.currentId && record.idNew !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      if (!this.expandedRowKeys.includes(record.idNew)) {
        this.expandedRowKeys.push(record.idNew)
      }
      // 主动展开获取获取，并新增
      this.getChild(true, record, obj)
    },
    // 表格点击获取子级
    getChild (expanded, record, val) {
      // expanded判断展开or收缩操作，record当前行数据
      if (expanded) {
        const tableList = JSON.parse(JSON.stringify(this.$refs.dataTable.myDataSource))
        apiItemCategoryCodeList({ fatherSegments: record.fatherSegments.join(), pageSize: 100, pageNum: 1 }).then((res) => {
          if (res.rows && res.rows.length > 0) {
            for (let i = 0; i < res.rows.length; i++) {
              res.rows[i].idNew = `${res.rows[i].idNew}${res.rows[i].segment}`
              // 最多5层
              if (record.indexArr.length <= 4) {
                res.rows[i].children = []
              }
              // 子节点的传参
              const obj = JSON.parse(JSON.stringify(record))
              obj.fatherSegments.push(res.rows[i].segment)
              obj.segmentNames.push(res.rows[i].segmentName)
              res.rows[i].fatherSegments = obj.fatherSegments
              res.rows[i].segmentNames = obj.segmentNames
              // 定位树数据的哪一条
              obj.indexArr.push(i)
              res.rows[i].indexArr = obj.indexArr
            }
            // 点击添加子项
            if (val) {
              val.fatherSegments = record.fatherSegments
              val.segmentNames = record.segmentNames
              res.rows.unshift(val)
            }
            this.handleTableList(tableList, record, res.rows)
          } else {
            // 点击添加子项
            if (val) {
              const arr = []
              val.fatherSegments = record.fatherSegments
              val.segmentNames = record.segmentNames
              arr.push(val)
              this.handleTableList(tableList, record, arr)
            }
          }
          // 点击添加子项
          if (val) {
            this.isEdit = true;
            this.currentId = val.idNew;
          }
          this.$refs.dataTable.myDataSource = tableList
        })
      }
    },
    // 层级树插入数据
    handleTableList (tableList, record, list) {
      if (record.indexArr.length === 1) {
        tableList[record.indexArr[0]].children = list
      }
      if (record.indexArr.length === 2) {
        tableList[record.indexArr[0]].children[record.indexArr[1]].children = list
      }
      if (record.indexArr.length === 3) {
        tableList[record.indexArr[0]].children[record.indexArr[1]].children[record.indexArr[2]].children = list
      }
      if (record.indexArr.length === 4) {
        tableList[record.indexArr[0]].children[record.indexArr[1]].children[record.indexArr[2]].children[record.indexArr[3]].children = list
      }
    },
    // 列表请求
    onSearch () {
      this.isEdit = false
      this.$refs.dataTable.searchParams = this.queryParams;
      this.$refs.dataTable.getData();
    },
    // 编辑
    handleEdit (record) {
      if (this.currentId && record.idNew !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }

      this.isEdit = true;
      this.currentId = record.idNew;
    },
    // 编辑-保存
    handleSave (item) {
      const record = JSON.parse(JSON.stringify(item))
      record.categorySetId = this.queryParams.categorySetIds
      if (record.idNew === "add" && !record.fatherSegments) {
        const arr = []
        const arr2 = []
        if (record.segment) {
          arr.push(record.segment)
        }
        if (record.segmentName) {
          arr2.push(record.segmentName)
        }
        record.segments = arr
        record.segmentNames = arr2
      } else if (record.idNew === "add" && record.fatherSegments.length > 0) {
        record.fatherSegments.push(record.segment)
        record.segments = record.fatherSegments
        record.segmentNames.push(record.segmentName)
      } else {
        record.segments = record.fatherSegments
      }
      if (record.idNew === "add") {
        // 新增
        const arr3 = []
        arr3.push(record)
        apiItemCategoryCodeAdd(arr3).then(response => {
          if (response.code === 200) {
            this.$message.success('保存成功')
            this.handleQuery()
          } else {
            this.$message.error(response.msg)
          }
        })
      } else {
        // 修改
        apiItemCategoryCodeEdit(record).then(response => {
          if (response.code === 200) {
            this.$message.success('保存成功')
            this.handleQuery()
          } else {
            this.$message.error(response.msg)
          }
        })
      }
    },
    // 取消
    handleCancel (record) {
      this.handleQuery()
    },
    // 导入导出excel
    /** 导出按钮操作 */
    handleExport () {
      this.download('mdm/itemCategoryCode/export', {
        ...this.queryParams
      }, `类别代码_${new Date().getTime()}.xlsx`)
    },
    cancelHandleStatus (row) {},
    /** 搜索按钮操作 */
    handleQuery () {
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        categorySetIds: undefined,
        categoryDesc: undefined,
        barcodeEnabled: undefined,
        deliveryTypes: undefined,
        status: undefined,
        fatherSegments: ""
      }
      this.queryParams.categorySetIds = this.$route.query && this.$route.query.id || null;
      this.handleQuery()
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    statusOnChange (record, dataIndex) {
      record[dataIndex] = record[dataIndex] === 'Y' ? 'N' : 'Y'
    },
    selectChange (val, record) {},
    meaning (record, dataIndex) {
      if (dataIndex === "plannerId") {
        return record['userName']
      }
      if (dataIndex === "deliveryType") {
        return record['deliveryTypeDesc']
      }
      return record[dataIndex]
    },
    setArray (arr) {
      return this[arr]
    }
  }
}
</script>

<style scoped lang="less">
.page-header-content{
  /deep/.ant-select{
    width: 140px;
  }
  input{
    width: 140px;
  }
}
</style>
